"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.errd = exports.err = void 0;
function err(p, errorMessage) {
    return {
        parse: function (token) {
            var branches = p.parse(token);
            if (branches.successful) {
                return branches;
            }
            return {
                successful: false,
                error: {
                    kind: 'Error',
                    pos: branches.error.pos,
                    message: errorMessage
                }
            };
        }
    };
}
exports.err = err;
function errd(p, errorMessage, defaultValue) {
    return {
        parse: function (token) {
            var branches = p.parse(token);
            if (branches.successful) {
                return branches;
            }
            return {
                successful: true,
                candidates: [{
                        firstToken: token,
                        nextToken: token,
                        result: defaultValue
                    }],
                error: {
                    kind: 'Error',
                    pos: branches.error.pos,
                    message: errorMessage
                }
            };
        }
    };
}
exports.errd = errd;
//# sourceMappingURL=ErrorParser.js.map